import script from "./BookCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BookCard.vue?vue&type=script&setup=true&lang=js"

import "./BookCard.vue?vue&type=style&index=0&id=cb5531ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb5531ca"]])

export default __exports__